// useGetOrderById.js
import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IOrder } from "@/interfaces/order.interfaces";
import orderService from "@/services/order.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetOrderByIdReturn = RequestsBaseReturn<IOrder | null>;

export type UseGetOrderByIdProps = ByIdRequestProps;

type UseSwrGetOrderByIdParams = [string, number];

const useGetOrderById = ({ _id }: UseGetOrderByIdProps): UseGetOrderByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IOrder, Error, UseSwrGetOrderByIdParams | null>(
    _id ? [SWR_KEYS.getOrderById, _id] : null,
    ([, orderId]) => orderService.getById(orderId.toString()),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetOrderById;
